import { render, staticRenderFns } from "./configFeature.vue?vue&type=template&id=2e683569&scoped=true&"
import script from "./configFeature.vue?vue&type=script&lang=js&"
export * from "./configFeature.vue?vue&type=script&lang=js&"
import style0 from "./configFeature.vue?vue&type=style&index=0&id=2e683569&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e683569",
  null
  
)

export default component.exports